import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useState } from 'react';
import PropTypes from "prop-types";
import { form_validator } from "../form/FormFieldValidator";
import FeatherIcon from "../ui/feather-icon/FeatherIcon";
import Feedback from "../feedback/Feedback";
import Spacer from "../ui/spacer/Spacer";
import { FormContext } from "noood/contexts/contexts";
import * as stylex from "@stylexjs/stylex";
export default function YesOrNo(props) {
  var _form_context$formObj, _props$validations;
  var _useState = useState(props.value),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    set_value = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    set_errors = _useState4[1];
  var useLiterals = props.useLiterals;
  var form_context = useContext(FormContext);
  var formValue = (_form_context$formObj = form_context.formObj) === null || _form_context$formObj === void 0 ? void 0 : _form_context$formObj[props.name];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ui-yesno"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: "13px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label, ((_props$validations = props.validations) === null || _props$validations === void 0 ? void 0 : _props$validations.indexOf('required')) > -1 ? " *" : null), props.question && /*#__PURE__*/React.createElement("span", {
    className: "ui-yesno-q"
  }, /*#__PURE__*/React.createElement("br", null), props.question), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  })), /*#__PURE__*/React.createElement("div", {
    className: "YesOrNo__ui.choices ev78zum5"
  }, /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.choice, formValue === (useLiterals ? 'Y' : 1) && ui.choice_active), {
    onClick: function onClick() {
      if (formValue === (useLiterals ? 'Y' : 1)) {
        var _form_context$__colle;
        set_value(null);
        form_context === null || form_context === void 0 || (_form_context$__colle = form_context.__collect) === null || _form_context$__colle === void 0 || _form_context$__colle.call(form_context, props.name, null, form_validator.validate(props.validations, null));
      } else {
        var _form_context$__colle2;
        set_value(useLiterals ? 'Y' : 1);
        form_context === null || form_context === void 0 || (_form_context$__colle2 = form_context.__collect) === null || _form_context$__colle2 === void 0 || _form_context$__colle2.call(form_context, props.name, useLiterals ? 'Y' : 1, form_validator.validate(props.validations, null));
      }
    }
  }), /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: formValue === (useLiterals ? 'Y' : 1) ? "check-circle" : "circle"
  }), "\xA0\xA0Yes"), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.choice, formValue === (useLiterals ? 'N' : 0) && ui.choice_active), {
    onClick: function onClick() {
      if (formValue === void 0 || formValue === null) {
        var _form_context$__colle3;
        set_value(useLiterals ? 'N' : 0);
        form_context === null || form_context === void 0 || (_form_context$__colle3 = form_context.__collect) === null || _form_context$__colle3 === void 0 || _form_context$__colle3.call(form_context, props.name, useLiterals ? 'N' : 0, form_validator.validate(props.validations, useLiterals ? 'N' : 0));
      } else {
        if (formValue === (useLiterals ? 'N' : 0)) {
          var _form_context$__colle4;
          set_value(null);
          form_context === null || form_context === void 0 || (_form_context$__colle4 = form_context.__collect) === null || _form_context$__colle4 === void 0 || _form_context$__colle4.call(form_context, props.name, null, form_validator.validate(props.validations, useLiterals ? 'N' : 0));
        } else {
          var _form_context$__colle5;
          set_value(useLiterals ? 'N' : 0);
          form_context === null || form_context === void 0 || (_form_context$__colle5 = form_context.__collect) === null || _form_context$__colle5 === void 0 || _form_context$__colle5.call(form_context, props.name, useLiterals ? 'N' : 0, form_validator.validate(props.validations, useLiterals ? 'N' : 0));
        }
      }
    }
  }), /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: formValue === (useLiterals ? 'N' : 0) ? "check-circle" : "circle"
  }), "\xA0\xA0No")), /*#__PURE__*/React.createElement(Feedback, {
    errors: errors
  })), props.spacer ? /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.spacer
  }) : null);
}
YesOrNo.displayName = '__yes_or_no';
YesOrNo.propTypes = {
  label: PropTypes.string,
  question: PropTypes.string,
  value: PropTypes.bool,
  validations: PropTypes.array,
  spacer: PropTypes.number
};

// @ts-ignore
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev761oyd{padding:8px 20px}", 1000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev14abgrs:hover{background-color:var(--shade-15)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);
_inject(".evksgmmf:first-of-type{border-top-left-radius:var(--roundness)}", 4053);
_inject(".evwr4vtk:first-of-type{border-bottom-left-radius:var(--roundness)}", 4053);
_inject(".evp9o1oi:first-of-type{border-right:1px solid var(--shade-20)}", 2053);
_inject(".ev1mggirv:last-of-type{border-top-right-radius:var(--roundness)}", 4055);
_inject(".ev1ydnvkp:last-of-type{border-bottom-right-radius:var(--roundness)}", 4055);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".ev1tzx33q{color:var(--text-on-accent)}", 3000);
var ui = {
  choice: {
    "YesOrNo__ui.choice": "YesOrNo__ui.choice",
    padding: "ev761oyd",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    cursor: "ev1ypdohk",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "evji57aj ev14abgrs ev1ko5yus",
    ":first-of-type_borderTopLeftRadius": "evksgmmf",
    ":first-of-type_borderStartStartRadius": null,
    ":first-of-type_borderStartEndRadius": null,
    ":first-of-type_borderBottomLeftRadius": "evwr4vtk",
    ":first-of-type_borderEndStartRadius": null,
    ":first-of-type_borderEndEndRadius": null,
    ":first-of-type_borderRight": "evp9o1oi",
    ":first-of-type_borderRightWidth": null,
    ":first-of-type_borderInlineStartWidth": null,
    ":first-of-type_borderInlineEndWidth": null,
    ":first-of-type_borderRightStyle": null,
    ":first-of-type_borderInlineStartStyle": null,
    ":first-of-type_borderInlineEndStyle": null,
    ":first-of-type_borderRightColor": null,
    ":first-of-type_borderInlineStartColor": null,
    ":first-of-type_borderInlineEndColor": null,
    ":last-of-type_borderTopRightRadius": "ev1mggirv",
    ":last-of-type_borderStartStartRadius": null,
    ":last-of-type_borderStartEndRadius": null,
    ":last-of-type_borderBottomRightRadius": "ev1ydnvkp",
    ":last-of-type_borderEndStartRadius": null,
    ":last-of-type_borderEndEndRadius": null,
    $$css: true
  },
  choice_active: {
    "YesOrNo__ui.choice_active": "YesOrNo__ui.choice_active",
    backgroundColor: "evwnonoy",
    color: "ev1tzx33q",
    $$css: true
  }
};